import gql from 'graphql-tag';

export const UPDATE_LOOK_USER_FILTER = gql`
  mutation updateLookUserFilter($filter: UserFilterInput!, $orderBy: [String]) {
    updateLookUserFilter(filter: $filter, orderBy: $orderBy) @client
  }
`;
